import React, { useState, useEffect } from 'react'
import "../Components/css/Navbar.css"
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
const servicesData = [
    {
        id: 1,
        category: "Salesforce",
        icon: "ri-cloud-line",
        subcategories: [
            { id: 1, name: "Salesforce Health Cloud" },
            { id: 2, name: "Salesforce Data Cloud" },
            { id: 3, name: "Salesforce Revenue Cloud (CPQ)" },
            { id: 4, name: "Salesforce Agentforce" },
            { id: 5, name: "Salesforce Marketing Cloud" },
            { id: 6, name: "Salesforce Field Service" },
            { id: 7, name: "Salesforce Experience Cloud" },
            { id: 8, name: "Salesforce Service Cloud" },
            { id: 9, name: "Salesforce Implementation" }
        ]
    },
    {
        id: 2,
        category: "Integration",
        icon: "ri-links-line",
        subcategories: [
            { id: 10, name: "MuleSoft" },
            { id: 11, name: "Celigo" },
            { id: 12, name: "QuickBooks" },
            { id: 13, name: "NetSuite" },
            { id: 14, name: "DocuSign" },
            { id: 15, name: "Zapier" },
            { id: 16, name: "Twilio" },
            { id: 17, name: "Stripe" },
            { id: 18, name: "Slack" }
        ]
    },
    {
        id: 3,
        category: "Marketing Automation",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 19, name: "Salesforce Marketing Cloud Next" },
            { id: 20, name: "Salesforce Marketing Cloud Advanced" },
            { id: 21, name: "HubSpot Implementation" },
            { id: 22, name: "Braze" }
        ]
    },
    {
        id: 4,
        category: "Strategy & Advisory",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 23, name: "Digital Transformation" },
            { id: 24, name: "Platform Migration" },
            { id: 25, name: "Technology Revamp" },
            { id: 26, name: "Data Governance and Security" }
        ]
    },
    {
        id: 5,
        category: "Snowflake",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 27, name: "Snowflake Implementation & Migration" },
            { id: 28, name: "Data Engineering & Pipelines" },
            { id: 29, name: "Data Warehousing & BI Enablement" }
        ]
    },
    {
        id: 6,
        category: "DevOps",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 30, name: "AWS" },
            { id: 31, name: "Copado" },
            { id: 32, name: "Gearset" },
            { id: 33, name: "Azure" }
        ]
    },
    {
        id: 7,
        category: "AI",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 34, name: "Chat Agents" },
            { id: 35, name: "Voice Agents" },
            { id: 36, name: "Sales Agents (sentiment)" },
            { id: 37, name: "AI Service Agents" }
        ]
    },
    {
        id: 8,
        category: "Design",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 38, name: "Prototyping & Wireframing" },
            { id: 39, name: "User Experience" },
            { id: 40, name: "Design Thinking" }
        ]
    },
    {
        id: 9,
        category: "Healthcare Solutions",
        icon: "ri-megaphone-line",
        subcategories: [
            { id: 41, name: "EDI Processor" },
            { id: 42, name: "FHIR & HL7 Integration" }
        ]
    },
    {
        id: 10,
        category: "Others",
        icon: "ri-bar-chart-box-line",
        subcategories: [
            { id: 43, name: "MS Dynamics" },
            { id: 44, name: "ServiceNow" },
            { id: 45, name: "Zoho" }
        ]
    }
];
export default function ServiceDropdown(props) {
    const [isdropdownState, setIsdropdownState] = useState(false);
    const [openCategory, setOpenCategory] = useState(null);
    const location = useLocation();
    const [windowDimension, detectHW] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
    });

	    const isWhiteBg =
	  location.pathname.includes("/customer-stories/") ||
	  location.pathname.includes("/services/") ||
	  location.pathname.includes("/products/") ||
	  location.pathname.includes("/edi-converter") ||
	  location.pathname.includes("/careers") ||
	  location.pathname.includes("/events") ||
	  location.pathname.includes("/case-studies");

    /*
    *********************************************************************************************************
    *   @React Component Name       :       ServiceDropdown
    *   @Method                     :       detectSize
    *   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
    *   @Company                    :       Antrazal
    *   @Description                :       Tracks window resize to switch between mobile/desktop layouts
    *********************************************************************************************************
    */
    const detectSize = () => {
        detectHW({ winWidth: window.innerWidth, winHeight: window.innerHeight });
    };

    useEffect(() => {
        window.addEventListener('resize', detectSize);
        return () => window.removeEventListener('resize', detectSize);
    }, [windowDimension]);

    /*
    *********************************************************************************************************
    *   @React Component Name       :       ServiceDropdown
    *   @Method                     :       handleDropdown
    *   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
    *   @Company                    :       Antrazal
    *   @Description                :       Toggles the main Services dropdown open/close
    *********************************************************************************************************
    */
    const handleDropdown = () => {
        setIsdropdownState(current => !current);
        setOpenCategory(null);
    };

    /*
    *********************************************************************************************************
    *   @React Component Name       :       ServiceDropdown
    *   @Method                     :       toggleCategory
    *   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
    *   @Company                    :       Antrazal
    *   @Description                :       Mobile accordion — opens one category at a time
    *********************************************************************************************************
    */
    const toggleCategory = (id) => {
        setOpenCategory(prev => (prev === id ? null : id));
    };

    const toSlug = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')             
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

    const isMobile = windowDimension.winWidth < 1118;

    return (
        <li className={isdropdownState ? "dropdown__item show-dropdown" : "dropdown__item"}>

            <div
                className={`nav__link dropdown__button ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}
                onClick={handleDropdown}
            >
                Services
                <i className="ri-arrow-down-s-line dropdown__arrow"></i>
            </div>

            <div
                className={
                    isdropdownState
                        ? "dropdown__container height_dropdown"
                        : "dropdown__container dropdown__container2"
                }
                style={{ backgroundColor: "#fff" }}
            >
                {isMobile ? (
                
                    <div style={{ padding: "0.5rem 0" }}>
                        {servicesData.map((service) => (
                            <div key={service.id}>

                                <div
                                    onClick={() => toggleCategory(service.id)}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: "0.75rem 1.5rem",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #f0f0f0",
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
                                        <span style={{ fontWeight: 600, fontSize: "0.95rem", color: "#000" }}>
                                            {service.category}
                                        </span>
                                    </div>
                                    <i
                                        className="ri-arrow-down-s-line"
                                        style={{
                                            transition: "transform 0.3s",
                                            transform: openCategory === service.id ? "rotate(180deg)" : "rotate(0deg)",
                                            fontSize: "1.2rem",
                                        }}
                                    ></i>
                                </div>

                                {/* Subcategory List */}
                                {openCategory === service.id && (
                                    <div style={{ backgroundColor: "#fff", paddingLeft: "2.5rem", paddingBottom: "0.5rem" }}>
                                        {service.subcategories.map((sub) => (
                                            <Link
                                                key={sub.id}
                                                rel="canonical"
                                                to={`/services/${toSlug(sub.name)}`}
                                                onClick={() => props.handleState()}
                                                style={{
                                                    display: "block",
                                                    padding: "0.45rem 0.5rem",
                                                    fontSize: "0.85rem",
                                                    color: "#555",
                                                    textDecoration: "none",
                                                    borderBottom: "1px solid #eef0f5",
                                                }}
                                            >
                                                {sub.name}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div
                        className="dropdown__content"
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(5, 1fr)",
                            gridTemplateRows: "repeat(1, 1fr)",
                            gap: "1.5rem 2rem",
                            padding: "1.5rem",
                        }}
                    >
                        {servicesData.map((service) => (
                            <div
                                key={service.id}
                                className="dropdown__group"
                                style={{ flexDirection: "column", gap: "0rem" }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.4rem" }}>
                                    <h3
                                        className="dropdown__title"
                                        style={{
                                            fontSize: "0.9rem",
                                            marginBottom: "0",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.04em",
                                        }}
                                    >
                                        {service.category}
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        height: "1px",
                                        background: "linear-gradient(to right, #2C58ED, #9B1EA4)",
                                        borderRadius: "2px",
                                        marginBottom: "0.5rem",
                                    }}
                                ></div>

                                <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                                    {service.subcategories.map((sub) => (
                                        <Link
                                            key={sub.id}
                                            rel="canonical"
                                            to={`/services/${toSlug(sub.name)}`}
                                            onClick={() => props.handleState()}
                                            className="dropdown__link hover-underline"
                                            style={{
                                                fontSize: "0.82rem",
                                                color: "#555",
                                                textDecoration: "none",
                                                padding: "3px 4px",
                                                borderRadius: "4px",
                                                transition: "background 0.2s, color 0.2s",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                            }}

                                        >
                                            {sub.name}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </li>
    );
}
